import './Subjects.css'
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getStudentSubjects, getTeacherSubjects } from "../../redux/slices/subjectsSlice";
import { useDarkMode } from "../../contexts/DarkModeContext";
import "./Subjects.css";
import { Link } from 'react-router';

export default function Subjects() {
  const dispatch = useDispatch();
  const { isDarkMode } = useDarkMode();
  const { studentSubjects, teacherSubjects, subjectsLoading, subjectsError } = useSelector((state) => state.subjects);
  const { currentUser } = useSelector((state) => state.auth);
  
  const userRole = currentUser?.role || localStorage.getItem("userRole");
  const isTeacher = userRole === "teacher";
  
  // تحديد المواد التي سيتم عرضها
  const subjectsToShow = isTeacher ? teacherSubjects : studentSubjects;

  // Mapping للأيقونات حسب اسم المادة
  const getSubjectIcon = (subjectTitle) => {
    const iconMap = {
      "الرياضيات": "/math.png",
      "الدراسات الاجتماعية": "/drasat.png",
      "اللغة العربية": "/arabic.png",
      "العلوم": "/science.png",
      "الجغرافيا": "/gohraphia.png",
      "الفيزياء": "/physic.png",
      "التاريخ": "/tarekh.png",
      "اللغة الإنجليزية": "/english.png", // للتوافق مع البيانات القادمة من API
    };
    return iconMap[subjectTitle] || "/science.png"; // أيقونة افتراضية إذا لم توجد
  };

  // جلب المواد الدراسية عند تحميل المكون
  useEffect(() => {
    if (isTeacher) {
      dispatch(getTeacherSubjects());
    } else {
      dispatch(getStudentSubjects());
    }
  }, [dispatch, isTeacher]);

  // لإضافة Animation عند تحميل الصفحة
  useEffect(() => {
    const cards = document.querySelectorAll(".subject-card");
    cards.forEach((card, i) => {
      setTimeout(() => {
        card.classList.add("show");
      }, i * 150);
    });
  }, [subjectsToShow]); // إعادة تشغيل عند تغيير البيانات

  // عرض loading إذا كانت البيانات قيد التحميل
  if (subjectsLoading) {
    return (
      <section className={`subjects-section ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
        <div className="container text-center">
          <h3 className="subjects-subtitle">فئات علمي</h3>
          <h2 className="subjects-title">اتعلم جميع المواد</h2>
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="loading-spinner">جاري تحميل المواد الدراسية...</div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  // عرض error إذا كان هناك خطأ
  if (subjectsError) {
    return (
      <section className={`subjects-section ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
        <div className="container text-center">
          <h3 className="subjects-subtitle">فئات علمي</h3>
          <h2 className="subjects-title">اتعلم جميع المواد</h2>
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="error-message">حدث خطأ في تحميل المواد الدراسية</div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className={`subjects-section ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
      <div className="container text-center">
        <h3 className="subjects-subtitle">فئات علمي</h3>
        <h2 className="subjects-title">اتعلم جميع المواد</h2>

        <div className="row justify-content-center">
          {subjectsToShow.map((subject, index) => (
            <div className="col-md-6 col-lg-3 col-12 mb-4" key={subject.id}>
              <Link to={isTeacher ? `/lessons` : `/subject-teachers/${subject.id}`} className='text-decoration-none'>

                <div className="subject-card">
                  <img
                    style={{ width: "50px", height: "50px" }}
                    src={getSubjectIcon(subject.title)}
                    alt={subject.title}
                    className="subject-icon"
                  />
                  <h3 className="subject-name">{subject.title}</h3>

                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
